let apiBase = {
  queryList: '/api/identifyApkPretrial/queryPage',//应用预预审列表
  queryIdentifyDetail: '/api/identifyApkPretrial/queryDetail',//应用预预审应用详情
  exportIdentify: '/api/identifyApkPretrial/export',//应用预预审导出
  editIdentifyState: '/api/identifyApkPretrial/editState',//应用预预审审核
}
let preAuditServerObject = null

class preAuditServer {
  constructor() {
  }
  queryList(data = {}) {
    return $http({
      url: apiBase.queryList,
      method: 'post',
      data: data,
    })
  }
  queryIdentifyDetail(data = {}) {
    return $http({
      url: apiBase.queryIdentifyDetail,
      method: 'post',
      data: data,
    })
  }
  exportIdentify(data = {}) {
    return $http({
      url: apiBase.exportIdentify,
      method: 'post',
      data: data,
    })
  }
  editIdentifyState(data = {}) {
    return $http({
      url: apiBase.editIdentifyState,
      method: 'post',
      data: data,
    })
  }
}

function singPreAuditServerObject() {
  if (preAuditServerObject === null) {
    preAuditServerObject = new preAuditServer()
  }
  return preAuditServerObject
}

export default singPreAuditServerObject()
